import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SupplierItem } from 'src/app/models/supplier-item.model';
import { Supplier } from 'src/app/models/supplier.model';
import { InventoryService } from 'src/app/services/inventory.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: '[app-tr-supplier-item]',
  template: `
    <td class="align-middle">
      <div class="d-flex">
        <div>
          <img src="{{ supplierItem?.id }}" style="max-width: 20px;">
        </div>
        {{ supplierItem?.name }}
      </div>
    </td>
    <td class="align-middle text-center">{{ supplierItem?.code }}</td> 
    <td class="align-middle text-center">{{ supplierItem?.unit_price }}</td>
    <td class="align-middle text-center">{{ supplierItem?.minimum_order_quantity }}</td>
    <td class="align-middle text-center">{{ supplierItem?.active }}</td>
    <td class="align-middle text-center">
      <div class="btn-group">
        <button 
          class="btn btn-primary btn-sm me-2"
          (click)="editItem()">
          <fa-icon [icon]="icons.faEdit"></fa-icon>
          Edit
        </button>
        <button 
          class="btn btn-danger btn-sm"
          (click)="confirmDelete()"
          [disabled]="isDeleting">
          <fa-icon [icon]="icons.faTrashAlt"></fa-icon>
          {{ isDeleting ? 'Deleting...' : 'Delete' }}
        </button>
      </div>
    </td>
      
  `,
  styles: ``
})
export class TrSupplierItemComponent {
  @Input() supplier: Supplier | null = null;
  @Input() supplierItem: SupplierItem | null = null;
  @Input() profile: any;
  @Input() permissions: any;
  @Output() editRequested = new EventEmitter<SupplierItem>();
  @Output() itemDeleted = new EventEmitter<string>();

  isDeleting: boolean = false;

  constructor(
    private inventoryService: InventoryService,
    private toastr: ToastrService,
    public icons: IconsService
  ) {
    // Initialization logic can go here if needed
  }

  ngOnChanges() {}

  confirmDelete() {
    if (confirm('Are you sure you want to delete this item?')) {
      this.deleteItem();
    }
  }

  editItem() {
    this.editRequested.emit(this.supplierItem!);
  }

  private deleteItem() {
    if (!this.supplierItem?.id) {
      this.toastr.error('Item ID not found');
      return;
    }

    this.isDeleting = true;
    this.inventoryService.deleteSupplierItem(this.supplier?.id!, this.supplierItem.id).subscribe({
      next: () => {
        this.toastr.success('Item deleted successfully');
        this.itemDeleted.emit();
        this.isDeleting = false;
      },
      error: (error) => {
        this.toastr.error('Error deleting item: ' + error.message);
        this.isDeleting = false;
      }
    });
  }
}
